import {reducerWithInitialState} from "typescript-fsa-reducers";
import { actions } from "../actions/Action";
import { deepCopyTableThingyState, deepCopyChangeJob, CredFormInitialState, toleranceFromInput } from "../typing/loginstate";



export default reducerWithInitialState(CredFormInitialState)
        .case(actions.createLicense, (state,payload) => {
            // create a deepcopy of state and update the variables 
            // ONLY UPDATE THE DEPCOPY AND RETURN IT
            const deepCopy=deepCopyTableThingyState(state);
            //deepCopy.model.user = payload.NewCred;
            
            return deepCopy;
        })
        .case(actions.SetMandant, (state,payload) => {
            const deepCopy=deepCopyTableThingyState(state);
            //deepCopy.model.user = payload.NewCred;
            deepCopy.model.mandant = payload.data;
            
            return deepCopy;
        })
        // Ohne diesen Fall blieb die Modulliste leer: Die Aktion wurde
        // ausgeloest, der Reducer kannte sie nicht, und im Formular stand unter
        // "Modules" nichts zum Anhaken.
        .case(actions.SetModules, (state,payload) => {
            const deepCopy=deepCopyTableThingyState(state);
            deepCopy.model.modules = payload.data;

            return deepCopy;
        })
        // Und ohne diesen wurde das Anhaken nirgends vermerkt. Der Haken sass,
        // die Auswahl war leer, und die Lizenz ging ohne Module hinaus.
        .case(actions.selectJob, (state,payload) => {
            return deepCopyChangeJob(state, payload.value, payload.checked ? "add" : "remove");
        })
        .case(actions.SetToleranceDefault, (state,payload) => {
            const deepCopy=deepCopyTableThingyState(state);
            deepCopy.model.toleranceDefault = payload.percent;

            return deepCopy;
        })
        .case(actions.SetFormData, (state,payload) => {
            // create a deepcopy of state and update the variables 
            // ONLY UPDATE THE DEPCOPY AND RETURN IT
            console.log("asdasdas");
            console.log(payload.data);
            const deepCopy=deepCopyTableThingyState(state);
             if (payload.type === "client")
                 deepCopy.model.license.mandant = payload.data;
             if (payload.type === "expTime")
                 deepCopy.model.license.expirationDate = payload.data;
             if (payload.type === "numberOfTarget")
                 deepCopy.model.license.numberOfTargets = payload.data;
            if (payload.type === "name")
                 deepCopy.model.license.licensedTo = payload.data;
            if (payload.type === "branch")
                 deepCopy.model.license.branch = payload.data;
            if (payload.type === "edition")
                deepCopy.model.license.edition = payload.data;
            if (payload.type === "software")
                 deepCopy.model.license.software = payload.data;
            // Empty field = hub default, sent as null.
            if (payload.type === "targetTolerance")
                 deepCopy.model.license.targetTolerancePercent = toleranceFromInput(payload.data);

           return deepCopy;
        })
        ;

        /// Props call immer [ber dispatch und diesen effekt